import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { FileController } from 'src/controllers/file.controller'
import { FileDto } from 'src/dto/file.dto'

const fileController = new FileController()

export function useGetFileList(entity: string, referenceId?: string) {
  const { userFarm: farmId } = useAuth()

  return useQuery<FileDto[], Error>({
    queryKey: ['getFileList', farmId, entity, referenceId],
    queryFn: () => fileController.listFiles(farmId!, entity, referenceId!),
    enabled: !!farmId && !!referenceId
  })
}
